import { FooterV3 } from '../FooterV3'

type LayoutProps = {
  children: React.ReactNode
  className?: string
}

const Layout = ({ className, children }: LayoutProps) => {
  return (
    <div className={`bg-white ${className} h-screen w-full px-4 md:px-12 pt-32 mx-auto  `}>
      <div className="max-w-[1400px] w-full mx-auto">{children}</div>
      <div className="max-w-[1400px] w-full mx-auto">
        <FooterV3 />
      </div>
    </div>
  )
}

export default Layout
